import { FormInitializerReturnType } from 'src/Configuration/validation'
import { WallboxConfigurationModel, WallboxPhaseType } from '../..'
import { EasyConnectModel } from '../../models/wallbox-configuration/wallbox-configuration-settings-form.model'
import useWallboxSettingsFormValidationFields from '../use-wallbox-settings-form-field-validations'
import { object } from 'yup'

const ALLOWED_NUMBER_PHASES: WallboxPhaseType[] = [1, 2, 3]

/**
 * Initializes the form for editing wallbox easy connect settings
 * @param model WallboxConfigurationModel
 * @returns initialValues and validationSchema for wallbox easy connect settings form
 */
export const useWallboxEasyConnectFormInitializer = (
  model?: WallboxConfigurationModel
): FormInitializerReturnType<EasyConnectModel, EasyConnectModel> => {
  const validationFields = useWallboxSettingsFormValidationFields()

  const initialValues = {
    sunModeActive: model?.sunModeActive ?? false,
    numberPhases: model?.numberPhases ?? 1,
    maxChargeCurrent: model?.maxChargeCurrent ?? 0,
    minChargeCurrent: model?.minChargeCurrent ?? 0,
    upperCurrentLimit: model?.upperCurrentLimit ?? 0,
    chargeStopHysteresis: model?.chargeStopHysteresis ?? 0,
    dhcpEnabled: model?.dhcpEnabled ?? false,
    ipAddress: model?.ipAddr ?? '',
    subnetMask: model?.subnetMask ?? '',
    gateway: model?.gateway ?? '',
    keyLockMode: model?.keyLockMode,
    rfidReaderEnabled: model?.rfidReaderEnabled,
    authRequired: Boolean(model?.authRequired),
  }

  const validationSchema = object().shape({
    sunModeActive: validationFields.sunModeActiveField(),
    numberPhases: validationFields.numberPhasesField(ALLOWED_NUMBER_PHASES),
    maxChargeCurrent: validationFields.maxChargeCurrentField(),
    upperCurrentLimit: validationFields.upperCurrentLimitField(),
    minChargeCurrent: validationFields.minChargeCurrentField(),
    chargeStopHysteresis: validationFields.chargeStopHysteresisField(),
    dhcpEnabled: validationFields.dhcpEnabledField(),
    ipAddress: validationFields.ipAddressField(),
    subnetMask: validationFields.subnetMaskField(),
    gateway: validationFields.gatewayField(),
    keyLockMode: validationFields.keyLockModeField(),
    rfidReaderEnabled: validationFields.rfidReaderEnabledField(),
    authRequired: validationFields.authRequiredField(),
  })
  return { initialValues, validationSchema }
}
